// extracted by mini-css-extract-plugin
module.exports = {"workers":"WorkersList_workers__D05RV","workersList":"WorkersList_workersList__1KGAO","worker":"WorkersList_worker__3pQmX","green":"WorkersList_green__3YaNN"};